// extracted by mini-css-extract-plugin
module.exports = {"header":"notifycenter_header__1E9jn","table":"notifycenter_table__2F7uA"};